module.exports = __webpack_public_path__ + "img/3_51.57baf591.png";